import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { ActivatedRouteSnapshot } from '@angular/router';
import { EntityDetailResolver } from 'src/app/core/services/entity-detail.resolver';
import { LiftModuleService } from './lift-module.service';
import { LiftModuleDetail } from '../models/lift-module-detail.model';
import { LiftParameterSettingsService } from './lift-parameter-settings.service';
import { LiftParameterSettingsDetail } from '../models/list-parameter-settings-detail';



@Injectable({ providedIn: 'root' })
export class LiftParameterSettingsDetailResolver extends EntityDetailResolver<LiftParameterSettingsService, LiftParameterSettingsDetail> {
  constructor(
    liftParameterSettingsService: LiftParameterSettingsService
  ) {
    super(liftParameterSettingsService);
  }
}
